import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import Switch from "@mui/material/Switch";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import backbluebtn from "../../../Utils/Images/backbluebtn.png";
import CustomButton from "../../../Components/Button/CustomButton";
import { handleAddController } from "../../../APIs/Function/Controller/Controller";
import { GetSingleController } from "../../../APIs/Function/Controller/SingleController";

const SingleSubAdmin = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [singleSubAdmin, setSingleSubadmin] = useState({});
  const label = { inputProps: { "aria-label": "Color switch demo" } };
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    privileges: [],
  });
  const initialFormData = {
    email: "",
    password: "",
    privillges: [],
  };
  const [privilege, setPrivilege] = useState([]);
  const [loading, setLoading] = useState(false);
  const [switchValues, setSwitchValues] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false,
  });

  const handleSwitchChange = (privilege) => {
    const updatedPrivileges = [...(singleSubAdmin.privileges || [])];

    if (singleSubAdmin && updatedPrivileges.includes(privilege)) {
      updatedPrivileges.splice(updatedPrivileges.indexOf(privilege), 1);
    } else {
      updatedPrivileges.push(privilege);
    }

    setFormData({
      ...formData,
      privileges: updatedPrivileges,
    });
  };

  const handleSinglecontroller = async () => {
    try {
      setLoading(true);
      let res = await GetSingleController(id);
      setLoading(false);
      console.log(res.r, "r");
      setSingleSubadmin(res.r);
      setPrivilege(res.r.privilege);
      setFormData({
        ...formData,
        email: res.r.email,
        privileges: res.r.privileges,
      });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (singleSubAdmin.privileges) {
      const initialSwitchState = { ...switchValues };

      Object.keys(initialSwitchState).forEach((privilege) => {
        initialSwitchState[privilege] = singleSubAdmin.privileges.includes(
          Number(privilege)
        );
      });

      setSwitchValues(initialSwitchState);
    }
  }, [singleSubAdmin.privileges]);

  useEffect(() => {
    handleSinglecontroller();
  }, []);
  console.log(singleSubAdmin);
  return (
    <>
      {loading ? (
        <Box sx={{ mt: "25%" }}>
          <CircularProgress></CircularProgress>
        </Box>
      ) : (
        <Box>
          {" "}
          <Box
            sx={{
              bgcolor: "#31AEF4",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: { xs: "50px", md: "70px", lg: "70px" },
              p: "10px",
              boxSizing: "border-box",
            }}
          >
            <Link to={"/controller"}>
              <Box
                sx={{
                  height: { xs: "50px", md: "60px", lg: "60px" },
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img height={"100%"} src={backbluebtn} alt="back" />
              </Box>
            </Link>
            <Box>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: { md: "30px", sm: "20px" },
                  fontWeight: 600,
                  lineHeight: "36px",
                  color: "#FFFFFF",
                }}
              >
                Sub Admin Details
              </Typography>
            </Box>
            <Box>
              <Link to={`/editsubadmin/${id}`}>
                <CustomButton
                  sx={{
                    width: { xs: "40px", md: "50px", lg: "80px" },
                    height: { xs: "10px", md: "50px", lg: "50px " },
                  }}
                >
                  {loading ? <CircularProgress></CircularProgress> : "Edit"}
                </CustomButton>{" "}
              </Link>
            </Box>
          </Box>
          <Box>
            <Container maxWidth="sm" sx={{ mt: "30px" }}>
              <form>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        border: "1px solid #E8E8E8",
                        height: "50px",
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "center",
                        color: "#737373",
                      }}
                    >
                      <Typography>Email : {singleSubAdmin?.email}</Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Paper>
                      <Box sx={{ display: "flex" }}>
                        <Box
                          sx={{
                            border: "1px solid #E8E8E8",
                            width: "50%",
                            p: 2,
                            boxSizing: "border-box",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center ",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "17px",
                                fontFamily: "Open Sans",
                                fontWeight: 400,
                                color: "#737373",
                              }}
                            >
                              User
                            </Typography>{" "}
                            <Switch
                              onChange={() => handleSwitchChange(1)}
                              checked={switchValues[1]}
                            />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center ",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "17px",
                                fontFamily: "Open Sans",
                                fontWeight: 400,
                                color: "#737373",
                              }}
                            >
                              Product
                            </Typography>
                            <Switch
                              onChange={() => handleSwitchChange(2)}
                              {...label}
                              checked={switchValues[2]}
                            />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center ",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "17px",
                                fontFamily: "Open Sans",
                                fontWeight: 400,
                                color: "#737373",
                              }}
                            >
                              Chat
                            </Typography>
                            <Switch
                              onChange={() => handleSwitchChange(3)}
                              {...label}
                              checked={switchValues[3]}
                            />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center ",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "17px",
                                fontFamily: "Open Sans",
                                fontWeight: 400,
                                color: "#737373",
                              }}
                            >
                              Order
                            </Typography>
                            <Switch
                              onChange={() => handleSwitchChange(4)}
                              {...label}
                              checked={switchValues[4]}
                            />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center ",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "17px",
                                fontFamily: "Open Sans",
                                fontWeight: 400,
                                color: "#737373",
                              }}
                            >
                              Coupon
                            </Typography>
                            <Switch
                              onChange={() => handleSwitchChange(5)}
                              {...label}
                              checked={switchValues[5]}
                            />
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            border: "1px solid #E8E8E8",
                            width: "50%",
                            p: 2,
                            boxSizing: "border-box",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center ",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "17px",
                                fontFamily: "Open Sans",
                                fontWeight: 400,
                                color: "#737373",
                              }}
                            >
                              Workout
                            </Typography>{" "}
                            <Switch
                              onChange={() => handleSwitchChange(6)}
                              {...label}
                              checked={switchValues[6]}
                            />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center ",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "17px",
                                fontFamily: "Open Sans",
                                fontWeight: 400,
                                color: "#737373",
                              }}
                            >
                              Home Page Links
                            </Typography>
                            <Switch
                              onChange={() => handleSwitchChange(7)}
                              {...label}
                              checked={switchValues[7]}
                            />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center ",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "17px",
                                fontFamily: "Open Sans",
                                fontWeight: 400,
                                color: "#737373",
                              }}
                            >
                              Voucher
                            </Typography>
                            <Switch
                              onChange={() => handleSwitchChange(8)}
                              {...label}
                              checked={switchValues[8]}
                            />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center ",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "17px",
                                fontFamily: "Open Sans",
                                fontWeight: 400,
                                color: "#737373",
                              }}
                            >
                              Notification
                            </Typography>
                            <Switch
                              onChange={() => handleSwitchChange(9)}
                              {...label}
                              checked={switchValues[9]}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </form>
            </Container>
          </Box>
        </Box>
      )}
    </>
  );
};

export default SingleSubAdmin;
